import React, { Fragment } from "react";
import { Container, Row, Col, Image} from "react-bootstrap";
import { Link } from "react-router-dom";


const Team = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/hackingCreativity/corpInnovation.jpg)', backgroundSize: 'cover'}}>
        <h1 className="display-3" style={{color:'white'}}>Team</h1>
      </div> 

      <Container className="m-5 p-5 border rounded border-primary">
         

         <Row className="mx-3 mb-5">
            <Col className="col-12 col-md-4 mt-5 text-center">
               <Image src="/images/hackingCreativity/PronitaMehrotra.JPG" fluid roundedCircle />
              
            </Col>

            <Col className="col-12 col-md-8">
            <h3> Pronita Mehrotra </h3>
               <p>
               Pronita is the <strong>Founder and CEO </strong> of MindAntix. Her work focuses on the neuroscience behind creative thinking and leverages cognitive thinking patterns in ideation and decision making. </p>
               <p>
               She has participated in several global conferences and conducted creativity workshops for organizations and leaders. She is the author of the book, <em>Think Like A Disruptor, Lead Like A Visionary</em>.  
Her work has been featured in leading publications like Harvard Business Review, ASCD, edCircuit and Education Week. MindAntix's educational product was awarded EdTech Digest’s Cool Tool 2020 Finalist award in the 21st century skills category. </p>
<p>
Apart from MindAntix, Pronita brings over 15 years of experience in research and software development in the technology industry. Prior to starting MindAntix, she worked at Microsoft in both development and program management. Pronita earned her Ph.D. in Electrical and Computer Engineering from North Carolina State University and her integrated Bachelors and Masters degree from Indian Institute of Technology, Mumbai.

               </p>
            </Col>
         </Row>

         <Row className="mx-3 mb-5">
            <Col className="col-12 col-md-4 mt-5 text-center">
               <Image src="/images/hackingCreativity/StevenRowell.jpg" fluid roundedCircle />
              
            </Col>

            <Col className="col-12 col-md-8">
               <h3> Steven Rowell</h3>
               <p> Steven is the <strong>VP of Process Excellence</strong> where he brings his decades of experience to ensure that MindAntix's organizational innovation programs are of the highest standards. He is also the founder of Accelerated Ventures and co-founder of Accelerator 
               Forum, where he helps successful business consultants and coaches license their best programs to corporations, grow with strategic partnerships, 
               and host business growth forums. </p>

               <p> He has worked with many Fortune 500 companies such as UPS, Walmart, Compass, Shell, Pfizer, and Huntsman. He has also licensed his patient 
                  satisfaction system to 1100 hospitals nationwide. He credits much of his success 
                  to the 7 years he spent opening new resorts for Walt Disney World. </p>
                  
               <p> He is the author of multiple books, including <em>Success from the Inside Out</em>; <em>Jumpstart Your Creativity</em>; and <em>How to Connect with
Anyone, Anywhere at Anytime </em>, with 208,000 books distributed globally. He
has shared stages with Les Brown, Jack Canfield, Kim Walsh Phillips and other renowned global speakers. </p>
<p> He performed improv with Wayne Brady in Las Vegas, and he occasionally sounds
just like Mickey Mouse, Goofy and Eeyore. He and his wife, an Emmy-award
winning filmmaker, producer, and podcaster, have one son, one foster daughter
from South Africa, Butterscotch, their Goldendoodle and a mischievous Corgi
named Courage</p>
            </Col>
         </Row>

            

      </Container>

      

      

      
      

    </Fragment>
       
  );
};
  
export default Team;